import { useEffect, useState } from 'react';
import { PageLayoutsContainer } from '@wajeez-web/components/layouts';
import {
  useContentSelector,
  SuggestContentActions,
} from '@wajeez-web/stores/content';
import { HandleTableData } from '@wajeez-web/components/data-table';
import { contentEntityDataType } from '@wajeez-web/stores/content';
import { Server } from '@wajeez/wajeez.microservices';
import { CheckBoxType } from '@wajeez-web/components/mui';
import { DataTableWrapper } from '@wajeez-web/components/helpers';

interface FilterableAppRequestOfSuggestContentColumnsExtended
  extends Server.FilterableAppRequestOfSuggestContentColumns {
  data: FilterableAppRequestOfSuggestContentColumnsExtended;
  totalCount: number | undefined;
}

const SuggestContent = () => {
  const { data, status } = useContentSelector((state) => state.suggestContent);

  const dataExtended =
    data as FilterableAppRequestOfSuggestContentColumnsExtended | null;

  const { setTablePreferences, tablePreferances, isTableReferencesLoading } =
    HandleTableData(
      'suggestContent',
      SuggestContentActions.getSuggestContentDataTableAsync
    );

  return (
    <PageLayoutsContainer
      title="Suggest Content"
      withoutRightPadding={true}
      breadCrumbsLinks={[{ title: 'Suggest-Content' }]}
    >
      <DataTableWrapper
        data={dataExtended?.data as contentEntityDataType}
        onHeaderManage={(header) => {
          const flags = header
            ?.filter((h) => h.selected)
            .reduce(
              (previousValue: number, currentValue: CheckBoxType) =>
                previousValue + Number(currentValue.value),
              0
            );

          tablePreferances &&
            flags &&
            setTablePreferences({
              ...tablePreferances,
              flags: flags + 1,
            });
        }}
        onPaginationChange={(pagination) => {
          tablePreferances &&
            setTablePreferences({
              ...tablePreferances,
              pageNumber: pagination.pageNumber,
              pageSize: pagination.pageSize,
            });
        }}
        sort={tablePreferances?.sortingOperations?.[0]}
        onSort={(sort) => {
          tablePreferances &&
            setTablePreferences({
              ...tablePreferances,
              sortingOperations: [sort],
            });
        }}
        onFilter={(filters, pagination) => {
          tablePreferances &&
            setTablePreferences({
              ...tablePreferances,
              pageNumber: pagination.pageNumber,
              filteringOperations: filters.map((f) => {
                return {
                  property: Number(f.key),
                  cretiria: f.value,
                  comparisonType: f.operator,
                };
              }),
            });
        }}
        isLoading={status === 'loading'}
        preferences={tablePreferances || undefined}
        setPreferences={setTablePreferences}
      />
    </PageLayoutsContainer>
  );
};

export default SuggestContent;
